<template>
  <sea-page-content
    ref="list"
    :fetchList="fetchList"
    :resetList="resetList"
    toolbar
    searchPanel
    in-tab
    hide-data-pub
    pulsanteAggiorna
    pulsanteValutaRichiesta
    pulsanteAccettaRichiesta
    pulsanteRifiutaRichiesta
    back
  >
    <template v-slot:table="{ attrs, height }">
      <v-data-table
        v-model="attrs.selected"
        v-bind="attrs"
        :height="height"
        :headers="headers"
        :items="items"
        sort-by="createdByLastName"
        dense
        :expanded="expanded"
        item-key="id"
        show-select
        @click:row="rowClick"
        @update:sort-by="sortBy"
      >
        <template v-slot:item.data="{ item }">
          {{ item.data | dateFormat }}
        </template>

        <template v-slot:item.tipo="{ item }">
          {{
            item.tipo &&
            tipiRichiesta.find((el) => el.value === item.tipo) &&
            tipiRichiesta.find((el) => el.value === item.tipo).text
          }}
        </template>
        <template v-slot:item.stato="{ item }">
          <v-icon
            v-if="item.stato === 'V'"
            :color="colors.primarycolor"
            class="material-icons"
          >
            hourglass_empty
          </v-icon>
          <v-icon
            v-else-if="item.stato === 'L'"
            :color="colors.primarycolor"
            class="material-icons-outlined"
          >
            thumb_up
          </v-icon>
          <v-icon
            v-else-if="item.stato === 'R'"
            :color="colors.primarycolor"
            class="material-icons-outlined"
          >
            thumb_down_alt
          </v-icon>
          <v-icon v-else class="material-icons" color="red">
            new_releases
          </v-icon>
        </template>
        <template v-slot:item.testo="{ item }">
          <div class="text-truncate" style="width: 150px">
            {{ item.testo }}
          </div>
        </template>
        <template v-slot:item.dettaglio="{ item }">
          <v-btn
            elevation="2"
            rounded
            x-small
            @click.stop="clicked(item)"
            :color="colors.primarycolor"
            dark
            class="mr-2"
          >
            info
            <v-icon right class="material-icons-outlined">info</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.visualizza="{ item }">
          <a @click.stop="download(item)">
            {{ item.nomeDoc }}
          </a>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div class="d-flex justify-center" style="width: 100%">
              <div style="width: 67vw">
                {{ item.testo }}
              </div>
            </div>
          </td>
        </template>
      </v-data-table>
    </template>
  </sea-page-content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";

const tipiRichiesta = [
  {
    text: "Modifica dati anagrafici",
    value: 1,
    error:
      "Per la tipologia di richiesta selezionata è necessario allegare il documento di modifica dati anagrafici, compilato e firmato, da scaricare dalla sezione 'Documenti'.",
  },
  {
    text: "Modifica IBAN",
    value: 2,
    error:
      "Per la tipologia di richiesta selezionata è necessario allegare il documento di modifica IBAN, compilato e firmato, da scaricare dalla sezione 'Documenti'.",
  },
  {
    text: "Modifica contatti",
    value: 3,
    error:
      "Per la tipologia di richiesta selezionata è necessario indicare nel campo testo i contatti da modificare (telefono, email ecc.).",
  },
  {
    text: "Richiesta documenti",
    value: 4,
    error:
      "Per la tipologia di richiesta selezionata è necessario indicare nel campo testo la descrizione del documento richiesto.",
  },
  {
    text: "Altre richieste",
    value: 5,
    error:
      "Per la tipologia di richiesta selezionata è necessario indicare nel campo testo la descrizione del documento richiesto.",
  },
];

const statiRichiesta = [
  { text: "Inviata", value: "I" },
  { text: "In valutazione", value: "V" },
  { text: "Lavorata", value: "L" },
  { text: "Rifiutata", value: "R" },
];

const headers = [
  {
    text: "Data",
    value: "data",
    sortable: false,
    filterable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Tipo",
    value: "tipo",
    sortable: false,
    filterable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Cognome",
    value: "createdByLastName",
    class: ["heading", "sort"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Nome",
    value: "createdByFirstName",
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Descrizione",
    value: "testo",
    sortable: false,
    filterable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Stato",
    value: "stato",
    sortable: false,
    filterable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Visualizza allegato",
    value: "visualizza",
    sortable: false,
    filterable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Dettaglio",
    value: "dettaglio",
    sortable: false,
    filterable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
];
export default {
  name: "requests-company",
  mixins: [mixin],
  data() {
    return {
      expanded: [],
      tipiRichiesta,
      statiRichiesta,
      headers,
    };
  },
  methods: {
    ...mapActions({
      fetchList: "docsAzi/fetchRequestsCons",
      resetList: "docsAzi/resetRequests",
      downloadReq: "docsAzi/downloadRequest",
    }),
    sortBy(val) {
      this.headers.forEach((h) => {
        h.class = ["text-little-2"];
        if (h.value === val) h.class.push("sort");
      });
    },
    rowClick(_, row) {
      row.select(!row.isSelected);
    },
    clicked(value) {
      const index = this.expanded.indexOf(value);
      if (index === -1) {
        this.expanded.length = 0;
        this.expanded.push(value);
      } else {
        this.expanded.splice(index, 1);
      }
    },
    download(item) {
      if (item.hasDoc) this.downloadReq(item);
    },
  },
  computed: {
    ...mapGetters({
      items: "docsAzi/requests",
    }),
  },
};
</script>

<style>
/** */
</style>
